import { render, staticRenderFns } from "./CreateInfo.vue?vue&type=template&id=645f2a85&scoped=true&"
import script from "./CreateInfo.vue?vue&type=script&lang=ts&"
export * from "./CreateInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CreateInfo.vue?vue&type=style&index=0&id=645f2a85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f2a85",
  null
  
)

component.options.__file = "CreateInfo.vue"
export default component.exports